<template>
  <!-- 在线咨询的正文 -->
  <div class="onlitdetstrter">
    <div class="onlitwt">
      <div class="wtbt">押金又不给退，又没有签过合同</div>
      <div class="wtlabel">
        <span>咨询时间：2021-04-22 08:12:38</span>
        <span>辽宁-葫芦岛</span>
      </div>
    </div>
    <div class="onlithd">
      <div class="hditem flex_start">
        <div class="hdlawcov">
          <img src="../../../assets/case/aaaa2_sample.png" alt="" />
        </div>
        <div class="lawjs">
          <div class="lawname flex_start">
            杨洋律师 <img src="../../../assets/case/uservipicon.png" />
          </div>
          <div class="lawsertiem">
            <span> 解答时间：2021-04-22 08:14:58</span
            ><span>服务地区：辽宁-葫芦岛</span>
          </div>
          <div class="lawjdnr">
            你好，要看你们如何约定才能确定，如果不按约定办理的话可以通过法院诉讼途径解决！
            微或电询。
          </div>
          <div class="lawbz">
            若有未尽事宜可以或致电
            <span class="dianhua">145-9888-1456</span>
            <span class="zxfztxt">（咨询请说明来自律观网）</span>
          </div>
          <div class="twbutn center">
            <img src="../../../assets/case/onlittwicon.png" alt="" /> 我也要提问
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.onlitdetstrter {
  width: 100%;
  padding: 38px 40px 12px;
  .onlitwt {
    padding-bottom: 40px;
    border-bottom: 1px solid #eeee;
    .wtbt {
      font-size: 24px;
      color: #000000;
    }
    .wtlabel {
      margin-top: 18px;
      font-size: 12px;
      color: #c8c8c8;
      span {
        margin-right: 20px;
      }
    }
  }
  .onlithd {
    .hditem {
      align-items: flex-start;
      padding: 30px 0;
      .hdlawcov {
        margin-right: 20px;
        img {
          width: 66px;
          height: 66px;
          border-radius: 4px;
        }
      }
      .lawjs {
        position: relative;
        .lawname {
          font-size: 16px;
          color: #0465ea;
          margin-top: 10px;
          img {
            margin-left: 8px;
            width: 16px;
            height: 16px;
          }
        }
        .lawsertiem {
          margin-top: 10px;
          font-size: 12px;
          color: #c8c8c8;
          span {
            margin-right: 20px;
          }
        }
        .lawjdnr {
          margin-top: 10px;
          font-size: 18px;
          color: #333333;
          line-height: 26px;
        }
        .lawbz {
          margin-top: 10px;
          font-size: 14px;
          color: #666666;
          .dianhua {
            color: #0465ea;
          }
          .zxfztxt {
            color: #c8c8c8;
          }
        }
        .twbutn {
          cursor: pointer;
          position: absolute;
          bottom: 0;
          right: 0;
          font-size: 14px;
          color: #ffffff;
          width: 140px;
          height: 38px;
          background: #ff4646;
          border-radius: 4px;
          img {
            width: 21px;
            height: 21px;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>